module.exports = __webpack_public_path__ + "static/media/jCourtney.cc460e49.jpeg";